import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from "../../Config/constants";
import { constructURL } from '../../Utils/index';
const service = AxiosClient.getInstance();

//Get Customer's users
export const getCustomerUsersApi = async (payload) => {
  const { activationKey, pagenumber = 1, searchKey = "", sort = 'ASC' } = payload;
  const baseUrl = `${ENV}${SERVICE.CUSTOMER.GET_CUSTOMER_USERS}`;
  const URL = constructURL(baseUrl, { activationKey, pagenumber, limit: 10, searchKey, sort });
  return service.GetApiRequest(URL);
};

// Fetches CUSTOMER list
export const getCustomerList = async (payload) => {
  console.log('\n Customer Service-------', payload);
  const { limit = 10, pagenumber = 1, searchKey = "", sort = 'ASC' } = payload;
  const url = constructURL(`${ENV}${SERVICE.CUSTOMER.GET_CUSTOMERS}`, { limit, pagenumber, sort, searchKey });
  return service.GetApiRequest(url);
};

export const getActivationKeyInfo = async (activationKey) => {
  const url = `${ENV}${SERVICE.CUSTOMER.ACTIVATION_KEY_INFO}?activationKey=${activationKey}`;
  return service.GetApiRequest(url);
}

export const getOnlineCustomersApi = async (payload) => {
  const { sort = 'ASC', searchKey = '', activationKey } = payload;
  const url = constructURL(`${ENV}${SERVICE.CUSTOMER.GET_ONLINE_CUSTOMERS}`, { activationKey, sort, searchKey  });
  return service.GetApiRequest(url);
}
